<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.codigo }} - {{ $t('descricao') }} : {{ item.descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVInventarioDePilha()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:properties="dataObject"
					:options="kebabOptions"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:backdrop="!planejamentoModelo"
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
		>
			<template #form>
				<div class="pr-8 pl-12 py-8">
					<h1 class="font-bold text-[#272728] text-2xl !m-0">
						{{ $t('stackProcessing') }}
					</h1>
					<p class="!m-0 text-[#272728] text-base">Defina os parâmetros de processamento</p>

					<div class="mt-4 flex flex-col gap-4">
						<div class="flex flex-col">
							<label class="font-semibold text-[#464947] text-sm uppercase">{{
								$t('description')
							}}</label>
							<InputText v-model="model.descricao" />
						</div>
						<div class="flex flex-col">
							<label class="font-semibold text-[#464947] text-sm uppercase">{{
								$t('measurement')
							}}</label>
							<DropdownFk
								v-model="model.medicaoId"
								:dropdown-options="medicoes"
								:disabled="isEdit"
							/>
						</div>
						<div>
							<label class="font-semibold text-[#464947] text-sm uppercase">{{
								$t('stackingFactor')
							}}</label>
							<RadioButton
								id="usar-fator"
								v-model="model.usarFatorObtidoNaMedicao"
								:disabled="isEdit"
								label="Usar fator obtido na medição"
								:model-value="true"
								name="fator-empilhamento"
							/>
							<RadioButton
								id="informar-fator"
								v-model="model.usarFatorObtidoNaMedicao"
								:disabled="isEdit"
								label="Usar fator informado"
								:model-value="false"
								name="fator-empilhamento"
							/>
							<InputText
								v-if="!model.usarFatorObtidoNaMedicao"
								v-model.number="model.fatorInformadoDeEmpilhamento"
								:disabled="isEdit"
								placeholder="Digite o fator de empilhamento"
							/>
						</div>
						<div class="flex flex-col gap-1">
							<label class="font-semibold text-[#464947] text-sm uppercase">{{
								$t('barkFactor')
							}}</label>
							<DropdownFk
								v-model="model.estratoInventarioCubagemId"
								placeholder="Escolha o inventário cubagem"
								:disabled="isEdit"
								:dropdown-options="inventariosCubagem"
							/>
							<RadioButton
								id="usar-cubagem"
								v-model="model.usarFatorDeCascaDeCubagem"
								:disabled="isEdit"
								label="Usar informação de cubagem"
								:model-value="true"
								name="fator-casca"
							/>
							<RadioButton
								id="informar-fator-casca"
								v-model="model.usarFatorDeCascaDeCubagem"
								:disabled="isEdit"
								label="Usar fator informado"
								:model-value="false"
								name="fator-casca"
							/>
							<InputText
								v-if="!model.usarFatorDeCascaDeCubagem"
								v-model.number="model.fatorInformadoDeCasca"
								:mask="['#.#', '#.##']"
								:disabled="isEdit"
								placeholder="Digite o fator de casca"
							/>
						</div>
						<div>
							<label class="font-semibold text-[#464947] text-sm uppercase">{{
								$t('significanceLevel')
							}}</label>
							<RadioButton
								id="90"
								v-model="model.nivelDeSignificancia"
								:disabled="isEdit"
								label="90%"
								:model-value="0.1"
								name="nivel-significancia"
							/>
							<RadioButton
								id="95"
								v-model="model.nivelDeSignificancia"
								:disabled="isEdit"
								label="95%"
								:model-value="0.05"
								name="nivel-significancia"
							/>
							<RadioButton
								id="99"
								v-model="model.nivelDeSignificancia"
								:disabled="isEdit"
								label="99%"
								:model-value="0.01"
								name="nivel-significancia"
							/>
						</div>
						<div class="flex flex-col">
							<label class="font-semibold text-[#464947] text-sm uppercase">{{
								$t('products')
							}}</label>
							<DropdownCheckboxFk
								v-model="model.produtos"
								:ignore-properties="['id', 'Nome']"
								:disabled="isEdit"
								:dropdown-options="produtos"
							/>
						</div>
					</div>

					<div class="container__crud__crudform__buttons">
						<Button
							:label="$t('cancel')"
							color="trv-secondary"
							outlined
							semantic-class="mini"
							@click="changeFormAndCloseAllActions"
						/>
						<Button
							v-if="!isEdit"
							:label="
								avancado
									? isEdit
										? $t('edit')
										: $t('process')
									: isEdit
										? $t('edit')
										: $t('process')
							"
							color="trv-default"
							semantic-class="mini"
							:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
							:loading="estaCarregando"
							@click="saveClick()"
						/>
						<Button
							v-else
							:label="
								avancado
									? isEdit
										? $t('edit')
										: $t('process')
									: isEdit
										? $t('edit')
										: $t('process')
							"
							color="trv-default"
							semantic-class="mini"
							:loading="estaCarregando"
							@click="saveClick()"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownCheckboxFk from '../../../components/DropdownCheckboxFk/DropdownCheckboxFk'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import KebabMenu from '../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../components/Pagination/Pagination'
import RadioButton from '../../../components/RadioButton/RadioButton'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	createEstratoInventarioPilha,
	deleteEstratoInventarioPilhaByIdList,
	getAllEstratoInventarioPilha,
	getMedicoesPilhaDropdown,
	updateEstratoInventarioPilha,
} from '../../../services/requests/EstratoInventarioPilhaRequests'
import { getAllProdutos } from '../../../services/requests/ProdutoRequest'

import { getAllEstratoInventarioCubagem } from '../../../services/requests/EstratoInventarioCubagemRequests'

import i18n from '../../../VueI18n'

import download from 'downloadjs'
import ExclusionAlert from '../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	name: 'ProcessamentoPilhas',
	components: {
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		RadioButton,
		DropdownFk,
		DropdownCheckboxFk,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	provide() {
		return {
			edit: this.edit,
		}
	},
	data() {
		return {
			produtos: [],
			medicoes: [],
			inventariosCubagem: [],
			modeloSalvo: undefined,
			processando: false,
			showExclusionAlert: false,
			escolhendoModelo: false,
			headersSelecionados: [
				'fatorDeEmpilhamentoValor',
				'dataDoProcessamento',
				'medicao',
				'descricao',
				'codigo',
			],
			intention: {},
			help: {},
			modeloEscolhido: '',
			index: 0,
			modelos: [],
			afilamentoVolumetrico: 'volumetrico',
			avancado: true,
			planejamentoModelo: false,
			mostrarLoadingProcessando: false,
			mensagemProcessando: this.$t('realizeOProcessamento'),
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				estratoInventarioPilhaId: '',
				eicb_tx_tipo_modelo: 'Volumetrico',
				medicaoId: '',
				estratoInventarioCubagemId: '',
				usarFatorObtidoNaMedicao: true,
				fatorInformadoDeEmpilhamento: '',
				usarFatorDeCascaDeCubagem: true,
				fatorInformadoDeCasca: '',
				nivelDeSignificancia: 0.01,
				produtos: [],
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				prefix: 'PC',
				subtitleCardPropertie: 'eicb_ds_descricao',
				titleCardPropertie: 'eicb_cd_codigo',
			},

			tableHeaders: [
				{ key: 'codigo', value: this.$t('code'), isActive: true },
				{
					key: 'descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'medicao',
					value: this.$t('measurement'),
					isActive: true,
				},
				{
					key: 'dataDoProcessamento',
					value: this.$t('processedDate'),
					isActive: true,
				},
				{
					key: 'fatorDeEmpilhamentoValor',
					value: this.$t('factor'),
					isActive: true,
				},
			],
			/**
			 * Cubagens para exibir no dropdown
			 */
			cubagens: [],
			/**
			 * Controlar se o botao de processar / editar esta fazendo chamada para o backend
			 */
			estaCarregando: false,
		}
	},
	computed: {
		initModel() {
			return {
				id: '',
				estratoInventarioPilhaId: '',
				eicb_tx_tipo_modelo: 'Volumetrico',
				medicaoId: '',
				estratoInventarioCubagemId: '',
				usarFatorObtidoNaMedicao: true,
				fatorInformadoDeEmpilhamento: '',
				usarFatorDeCascaDeCubagem: true,
				fatorInformadoDeCasca: '',
				nivelDeSignificancia: 0.01,
				produtos: [],
			}
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createEstratoInventarioPilhaToPost() {
			return {
				estratoInventarioPilhaId: uuidv4(),
				descricao: this.model.descricao,
				medicaoId: this.model.medicaoId,
				estratoInventarioCubagemId: this.model.estratoInventarioCubagemId,
				usarFatorObtidoNaMedicao: this.model.usarFatorObtidoNaMedicao,
				fatorInformadoDeEmpilhamento: this.model.fatorInformadoDeEmpilhamento,
				usarFatorDeCascaDeCubagem: this.model.usarFatorDeCascaDeCubagem,
				fatorInformadoDeCasca: this.model.fatorInformadoDeCasca,
				nivelDeSignificancia: this.model.nivelDeSignificancia,
				produtos: this.produtos
					.filter((produto) => this.model.produtos.includes(produto.id))
					.map((produto) => {
						return {
							produtoId: produto.id,
							diametroMinimo: produto[i18n.t('minDiameter')],
							diametroMaximo: produto[i18n.t('maxDiameter')],
						}
					}),
			}
		},
		edit() {
			return this.isEdit
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			let obrigatorios =
				this.model.descricao && this.model.medicaoId && this.model.nivelDeSignificancia

			if (!this.model.usarFatorDeCascaDeCubagem) {
				obrigatorios =
					obrigatorios &&
					this.model.fatorInformadoDeCasca > 0 &&
					this.model.fatorInformadoDeCasca <= 1
			}

			if (!this.model.usarFatorObtidoNaMedicao) {
				obrigatorios =
					obrigatorios &&
					this.model.fatorInformadoDeEmpilhamento > 0 &&
					this.model.fatorInformadoDeEmpilhamento <= 1
			}

			return obrigatorios
		},
	},

	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => {
				return model.id === value.properties.id
			})

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
				case 'visualizar':
					this.mutationShowMessage({
						messageTitle: this.$t('buscandoModelo'),
						messageText: '',
						messageIcon: 'far fa-info-circle',
						messageType: 'info',
					})

					get(model.id).then((response) => {
						this.isEdit = true
						this.model = model
						this.modelos = response.data.result
						this.planejamentoModelo = true
					})
					break
			}
		},
		afilamentoVolumetrico: {
			handler(value) {
				this.model.eicb_tx_tipo_modelo = value === 'volumetrico' ? 'Volumetrico' : 'Afilamento'
			},
			immediate: true,
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['eicb_cd_codigo']
		getAllEstratoInventarioPilha().then((response) => {
			response.data.forEach((estratoInventarioPilha) =>
				this.formataEstratoInventarioCubagemParaTabela(estratoInventarioPilha),
			)
			this.modelList = response.data
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getMedicoesPilhaDropdown().then((response) => {
			this.medicoes = response.data.result.map((pilha) => {
				return {
					id: pilha.id,
					[i18n.t('code')]: pilha.mdco_cd_codigo,
					[i18n.t('description')]: pilha.mdco_ds_descricao,
					[i18n.t('farm')]: pilha.fzda_nm_nome,
					[i18n.t('forestStratification')]: pilha.esfl_ds_descricao,
				}
			})
		})

		getAllProdutos().then((response) => {
			this.produtos = response.data.result.map((produto) => {
				return {
					id: produto.id,
					[i18n.t('code')]: produto.tppr_cd_codigo,
					Nome: produto.tppr_ds_descricao,
					[i18n.t('description')]: produto.tppr_ds_descricao,
					[i18n.t('minDiameter')]: produto.tppr_md_diametro_min,
					[i18n.t('maxDiameter')]: produto.tppr_md_diametro_max,
					[i18n.t('logLength')]: produto.tppr_md_comprimento_tora,
				}
			})
		})

		getAllEstratoInventarioCubagem().then((response) => {
			this.inventariosCubagem = response.data.result.map((estratoCubagem) => {
				return {
					id: estratoCubagem.id,
					[i18n.t('code')]: estratoCubagem.eicb_cd_codigo,
					[i18n.t('description')]: estratoCubagem.eicb_ds_descricao,
					[i18n.t('processedDate')]: new Date(
						estratoCubagem.eicb_dt_processamento,
					).toLocaleDateString(),
					[i18n.t('adjustedModel')]: estratoCubagem.eicb_tx_modelo_ajustado,
					[i18n.t('typeOfProcessing')]: estratoCubagem.eicb_tx_tipo_modelo,
					[i18n.t('model')]: estratoCubagem.nomeModelo,
				}
			})
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		verPlanejamento() {
			if (this.modelos.length) {
				this.planejamentoModelo = true
				this.showForm = false
			}
		},
		deletaProcessamento(estratoInventarioCubagemId) {
			deleteEstratoInventarioCubagemByIdList(estratoInventarioCubagemId).then(() => {
				const indexToRemove = this.modelList.map((m) => m.id).indexOf(estratoInventarioCubagemId)
				this.modelList.splice(indexToRemove, 1)
			})
		},
		handleInput(e) {
			this.headersSelecionados = e.map((m) => m.key)
		},
		saveModel() {},
		searchModel(text) {
			let modelo = this.modelos.find((modelo) =>
				modelo.stan_nm_titulo_modelo.toLowerCase().includes(text.toLowerCase()),
			)

			if (modelo) {
				this.index = this.modelos.indexOf(modelo)
				this.help = {}
			} else this.help = { message: this.$t('modelNotFound'), type: 'warning' }
		},
		handleClick(tipo) {
			this.avancado = tipo === 'avancado'
		},
		async registraInventarioCubagem() {
			this.processando = true
			this.mostrarLoadingProcessando = true
			this.mensagemProcessando = 'Aguarde enquanto os modelos são gerados'

			this.mutationShowMessage({
				messageTitle: this.$t('aviso'),
				messageText: this.$t('modelosGerados'),
				messageIcon: 'far fa-check-circle',
				messageType: 'info',
			})
			await registraEstratoInventarioProcessamento({
				eicb_ds_descricao: this.model.eicb_ds_descricao,
				fk_cbgm_cubagem: this.model.fk_cbgm_cubagem,
				eicb_tx_tipo_modelo: this.model.eicb_tx_tipo_modelo,
				eicb_dt_processamento: new Date(),
				eicb_dt_referencia: new Date(),
			})
				.then((response) => {
					this.model.id = response.data.result.id
					console.log(response)

					let treino

					if (response.status === 200) {
						treino =
							this.model.eicb_tx_tipo_modelo === 'Afilamento'
								? ajustaModeloAfilamento
								: ajustaModeloVolumetrico

						treino({
							EicbId: this.model.id,
							CubagemId: this.model.fk_cbgm_cubagem,
						})
							.then((response) => {
								this.modelos = response.data.result
								this.processando = false
								this.mostrarLoadingProcessando = false
							})
							.catch(() => {
								this.planejamentoModelo = false
								this.mostrarLoadingProcessando = false
								this.processando = false
								this.mutationShowMessage({
									messageTitle: this.$t('erro'),
									messageText: this.$t('falhaAoCriarProcessamento'),
									messageIcon: 'far fa-cross-circle',
									messageType: 'error',
								})

								this.deletaProcessamento([this.model.id])
							})
					}
				})
				.catch(() => {
					this.planejamentoModelo = false
					this.mostrarLoadingProcessando = false
					this.processando = false
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageText: this.$t('falhaAoCriarProcessamento'),
						messageIcon: 'far fa-cross-circle',
						messageType: 'error',
					})

					this.deletaProcessamento([this.model.id])
				})
		},

		/**
		 * Cria novo Estrato inventario pilha no banco de dados
		 */
		create() {
			this.estaCarregando = true

			createEstratoInventarioPilha(this.createEstratoInventarioPilhaToPost)
				.then((response) => {
					const { data: estratoInventarioCubagem, status } = response

					console.log('🚀 ~ file: Cubagem.vue:483 ~ create ~ response', response)

					this.estaCarregando = false
					this.disableSaveButton = false
					this.showForm = false

					if (status === 200) {
						this.cleanModel()
						this.formataEstratoInventarioCubagemParaTabela(estratoInventarioCubagem)

						this.modelList.unshift(estratoInventarioCubagem)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageText: '',
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageText: '',
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
				.catch(() => {
					this.estaCarregando = false
					this.disableSaveButton = false
				})
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataEstratoInventarioCubagemParaTabela(estratoInventarioCubagem) {
			estratoInventarioCubagem.isCheckedToDelete = false
			estratoInventarioCubagem.dataDoProcessamento = estratoInventarioCubagem.dataDoProcessamento
				? new Date(estratoInventarioCubagem.dataDoProcessamento).toLocaleDateString()
				: ''
			estratoInventarioCubagem.fatorDeEmpilhamentoValor =
				estratoInventarioCubagem.fatorDeEmpilhamentoValor.toFixed(3)
		},

		/**
		 * Atualiza estrato inventario cubagem no banco de dados
		 */
		update() {
			this.estaCarregando = true
			updateEstratoInventarioPilha({
				estratoInventarioPilhaId: this.model.id,
				descricao: this.model.descricao,
			})
				.then(() => {
					this.estaCarregando = false
					this.disableSaveButton = false

					const indexModel = this.modelList.map((m) => m.id).indexOf(this.model.id)

					this.$set(this.modelList, indexModel, this.model)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				})
				.catch(() => {
					this.estaCarregando = false
					this.disableSaveButton = false
				})
		},

		/**
		 * Exclui estrato inventario cubagem no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(estratoInventarioCubagem) =>
						this.modelsIdWithCheckedToDelete.includes(estratoInventarioCubagem.id) &&
						estratoInventarioCubagem.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteEstratoInventarioPilhaByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var estratoInventarioCubagemOrganizados = existeRegistroComDependencia
						.map(
							(estratoInventarioCubagem) =>
								`• ${estratoInventarioCubagem.eicb_cd_codigo} - ${estratoInventarioCubagem.eicb_ds_descricao}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('cubagemAtreladaAInventarioFlorestal')}:</b> <br/><br/> ${estratoInventarioCubagemOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			// this.disableSaveButton = true;
			// this.planejamentoModelo = true;
			// this.showForm = false;
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			this.model.usarFatorDeCascaDeCubagem = model.fatorDeCascaFoiInformado
			this.model.usarFatorObtidoNaMedicao = model.fatorDeEmpilhamentoFoiInformado

			this.model.fatorInformadoDeEmpilhamento = model.fatorDeEmpilhamentoValor
			this.model.fatorInformadoDeCasca = model.fatorDeCascaValor

			this.model.produtos = model.produtos.map((m) => m.produtoId)

			this.showForm = true
			this.isEdit = true
			// this.changeFormAndCloseAllActions();
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.model.usarFatorObtidoNaMedicao = true
			this.model.usarFatorDeCascaDeCubagem = true

			this.titleForm = `${this.$t('create')} ${this.$t('loggingProcessig')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
			this.modeloSalvo = []
			this.modelos = []
			this.model = { ...this.initModel }
		},

		/**
		 * Baixa os dados de processamentos de inventario de pilha
		 */
		downloadCSVInventarioDePilha() {
			let cabecalhoDoCsvPilha = ['Código', 'Descrição', 'Medição', 'Data do Processamento', 'Fator']
			const items = this.modelList

			const csv = [
				cabecalhoDoCsvPilha,
				...items.map((item) => [
					item.codigo,
					item.descricao,
					item.medicao,
					item.dataDoProcessamento,
					item.fatorDeEmpilhamentoValor,
				]),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, 'export_processamento_pilha.csv', 'text/csv')
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
